export const getFaqs = ({ faqReducer: { faq = [] } = {} }) => faq;
export const getFaqsFilter = ({ faqReducer: { filter = {} } = {} }) => filter;
export const getFaqsCount = ({ faqReducer: { count = 0 } = {} }) => count;
export const getCategories = ({ faqReducer: { categories = [] } = {} }) => categories;


